import { render } from "./SaleOrderSetting.vue?vue&type=template&id=2614aaba"
import script from "./SaleOrderSetting.vue?vue&type=script&lang=js"
export * from "./SaleOrderSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/miniProgram/setting/component/SaleOrderSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2614aaba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2614aaba', __exports__)) {
    api.reload('2614aaba', __exports__)
  }
  
  module.hot.accept("./SaleOrderSetting.vue?vue&type=template&id=2614aaba", () => {
    api.rerender('2614aaba', render)
  })

}


export default __exports__